// PageTracker -- tracks page_view events with duration on route change (iteration 061)

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/telemetry";

export default function PageTracker() {
  const location = useLocation();
  const pageRef = useRef<string | null>(null);
  const enteredAt = useRef<number>(Date.now());

  useEffect(() => {
    // Send duration for previous page
    if (pageRef.current) {
      track({
        type: "page_view",
        page: pageRef.current,
        duration_ms: Date.now() - enteredAt.current,
      });
    }
    // Record new page entry
    // Defer to next tick so data-page attribute is rendered
    const timer = setTimeout(() => {
      const el = document.querySelector("[data-page]");
      pageRef.current = el?.getAttribute("data-page") ?? location.pathname;
      enteredAt.current = Date.now();
    }, 0);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}
